import React from 'react';
import PropTypes from 'prop-types';

import helpers from 'helpers';

import AddSelectTextToTrain from './AddSelectTextToTrain';

class ContentAnnotations extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openAddWordSelection: false,
            textLetter: props.textLetter,
            selectedText: '',
        };

        this.onMouseUp = this.onMouseUp.bind(this);
        this.closePopover = this.closePopover.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { textLetter } = nextProps;

        this.setState({
            textLetter,
        });
    }

    onMouseUp(ev) {
        const range = helpers.getSelection(ev.target.parentNode);

        if (range.start === range.end) {
            return;
        }

        this.setState({
            openAddWordSelection: true,
            elementTarget: ev.target,
            selectedText: range.string,
        });
    }

    closePopover() {
        this.setState({
            openAddWordSelection: false,
        });
    }

    render() {
        const { selectedText, openAddWordSelection, elementTarget, textLetter } = this.state;
        const { changeSelectedTextToTrain } = this.props;

        return (
            <div>
                <AddSelectTextToTrain
                    openAddWordSelection={openAddWordSelection}
                    elementTarget={elementTarget}
                    closePopover={this.closePopover}
                    selectedText={selectedText}
                    changeSelectedTextToTrain={changeSelectedTextToTrain}
                />
                <div className='letter-text' onMouseUp={this.onMouseUp}>
                    {
                        textLetter.split('').map((item, key) => {
                            return <span key={key}>{item}</span>
                        })
                    }
                </div>
            </div>
        );
    }
}

ContentAnnotations.propTypes = {

};

ContentAnnotations.defaultProps = {

};

export default ContentAnnotations;



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Train/Content/Annotations.jsx